<template>
    <div>
        <section id="single-page-header">
            <div class="overlay">
                <div class="new-header-container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-left text-center">
                        <h2>{{ $t('tenders.single_header') }}</h2>
                    </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-right">
                        <ol class="breadcrumb float-right">
                        <li class="breadcrumb-item">
                            <router-link to="/" class="open_review">
                                {{ $t('menu.home') }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active"> {{ $t('menu.tenders') }} </li>
                        </ol>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section id="table" class="bg-white">
            <div class="new-container">
                <div class="row">
                    <div class="contact-area-left">
                        <h4>{{ $t('tenders.title') }}</h4>
                        <p v-if="!isAuthenticated">{{ $t('tenders.subtitle') }} </p>
                        <v-server-table :url="tableDataUrl" :columns="columns" :options="options">
                            <div slot="opening_finish_date" slot-scope="{row}" class="">
                                {{$moment(new Date(row.opening_date)).format('DD-MM-YYYY')}} - <br/><span class="text-primary font-weight-bold">{{$moment(new Date(row.finish_date)).format('DD-MM-YYYY HH:mm')}}</span>
                            </div>
                            <div slot="price" slot-scope="{row}" class="row justify-content-center">
                                <template v-if="isAuthenticated">
                                    <template v-if="me.package === 'Գոլդ'">
                                       <!-- <template v-if="row.type === 'ELECTRONIC'">
                                           
                                       </template>
                                       <template v-else> -->
                                            <div class="col-12">
                                                {{row.price}}
                                            </div>
                                            <div v-if="row.price_file" class="col-12">
                                                <a download target="_blank" :href="row.price_file">
                                                    <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light" data-toggle="modal" data-animation="bounce">
                                                    <i class="fa fa-download" />
                                                    </button>
                                                </a>
                                            </div>
                                       <!-- </template> -->
                                    </template>
                                    <template v-else>
                                        <span v-tooltip="'Նախահաշվային գինը հասանելի է միայն Գոլդ փաթեթ ունեցող օգտատերերին'">
                                            <i style="font-size: 24px"  class="fas fa-eye-slash"></i>
                                        </span>
                                    </template>
                                </template>
                                <template v-else>
                                    Մուտք գործեք համակարգ ինֆորմացիան ստանալու համար
                                </template>
                            </div>
                            <div slot="application" slot-scope="{row}" class="d-flex justify-content-center">
                                <template v-if="isAuthenticated">
                                    <template v-if="row.is_competition">
                                        <template v-if="row.kind === 'competitive'" >
                                            <template v-if="me.package === 'Գոլդ' || me.package === 'Պրեմիում'">
                                                <template v-if="!isNotNewProcedure(row)">
                                                    <button type="button" @click.stop="() => {$modal.show('application-modal', {...row, addToFavorite});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                                        Մրցույթի հայտ
                                                    </button>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <div v-tooltip="'Մրցույթի հայտ պատրաստելու գործիքը հասանելի է միայն Գոլդ կամ Պրեմիում փաթեթ ունեցող օգտատերերին'">
                                                <button disabled type="button" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                                    Մրցույթի հայտ
                                                </button>
                                                </div>
                                            </template>
                                        </template>
                                        <button v-if="row.kind === 'one_person'" type="button" @click.stop="() => {$modal.show('suggestion-modal', {...row, resetComponent});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                            Գնային առաջարկ 
                                        </button>
                                    </template>
                                </template>
                                <button v-else type="button" @click.stop="openApplicationModal" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                    Պատրաստել
                                </button>
                            </div>
                            <div slot="invitation" slot-scope="{row}" class="d-flex justify-content-center">
                                <template v-if="isAuthenticated || !row.is_closed">
                                    <a v-if="row.kind !== 'one_person'" download target="_blank" :href="invitationLinkFix(row.invitation_link)">
                                        <template v-if="me.package !== 'Անվճար' || !row.is_closed" >
                                            <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                                <i class="fa fa-download mr-1" /> Բեռնել
                                            </button>
                                        </template>
                                        <template v-else>
                                            <div v-tooltip="'Մրցույթի հրավերը բեռնելու համար թարմացրեք ձեր փաթեթի տեսակը'">
                                                <button disabled type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                                <i class="fa fa-download mr-1" /> Բեռնել
                                                </button>
                                            </div>
                                        </template>
                                    </a>
                                    <button v-else-if="row.organize.contract !== ''" type="button" @click.stop="$modal.show('contract-draft-modal', row)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                                        Պայմանագիր
                                    </button>
                                    <div class="ml-1 row align-items-center" v-if="row.guaranteed">
                                        <div class="col text-success">
                                            <i style="font-size: 32px" class="fas fa-shield-alt"></i>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    Մուտք գործեք համակարգ ինֆորմացիան ստանալու համար
                                </template>
                            </div>
                        </v-server-table>
                    </div>
                </div>
            </div>
        </section>
        <application-modal from="tenders" />
    </div>
</template>

<script>
import ApplicationModal from '../../private/participant/tenders/modals/ApplicationModal.vue'
export default {
    data() {
        return {
            columns: [
                'password',
                'title',
                'organizator',
                'opening_finish_date',
                'price',
                'application',
                'invitation',
            ],
            tableDataUrl: `${process.env.VUE_APP_API_URL}tender/landing`,
            options:{
                rowClassCallback: function(row) {
                    if(!row.is_closed){
                        return 'bg-light'
                    } else if(!row.is_closed){
                        return 'bg-light'
                    }
                },
                headings: {
                    password: 'Ծածկագիր',
                    title: 'Անվանում',
                    organizator: 'Պատվիրատու',
                    opening_finish_date: 'Ժամկետը սկիզբ/ավարտ',
                    region: 'Տարածաշրջան',
                    type: 'Տիպ',
                    price: 'Նախահաշվային գին',
                    application: 'Մրցույթի Հայտ',
                    invitation: 'Մրցույթի հրավեր',
                },
                columnsDropdown: false,
                filterable: false,
                sortable: [],
                pagination: { show: false },
                requestFunction(data) {
                    return this.$client.get(this.url, {params: data})
                    .catch(function (e) {this.dispatch('error', e)})
                },
                texts: {
                    count:
                    'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
                    first: 'Առաջին',
                    last: 'Վերջին',
                    filter: '',
                    filterPlaceholder: 'Փնտրել',
                    limit: '',
                    page: 'Page:',
                    noResults: 'Համընկնում չի գտնվել',
                    noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
                    filterBy: 'փնտրել ըստ {column}',
                    loading: 'Բեռնվում է...',
                    defaultOption: 'ընտրել {column}',
                    columns: 'Ընտրել դաշտերը',
                },
                skin: 'table table-hover'
            }
        }
    },
    computed: {
        locale() {
            return this.$store.getters['user/locale']
        },
        me() {
            return this.$store.getters['user/me']
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated
        },
    },
    name: 'TenderComponent',
    components: {ApplicationModal},
    methods:{
        invitationLinkFix(link){
            if(link.includes('https://gnumner.am')){
            return link.replace("https://gnumner.am/", "https://gnumner.minfin.am/");
            }
            return link;
        },
        isNotNewProcedure(row){
            switch (row.procedure.id) {
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
                return true
            default:
                return false
            }
        },
        addToFavorite(tenderStateId){
            const currTender = this.$refs.table.data.find(tender => tender.id === tenderStateId)
            if(!currTender.is_favorite){
                currTender.is_favorite = true;
                this.$client.post('/tender/favorite', {tender_state_id: tenderStateId})
            }
        },
        openApplicationModal(){
            this.$fire({
                text: "Խնդրում ենք մուտք գործել համակարգ հայտ պատրաստելու համար",
                type: "warning",
                confirmButtonText: 'Մուտք գործել',
            }).then((result) => {
                if (result.value) {
                    this.$router.push(`/login`);
                } else {
                }
            })
        }
    }
  }
</script>
<style>
    .pagination {
        display: none;
    }
</style>
<style scoped>
    @import '/assets/landing/css/slick.css';
    @import '/assets/landing/css/animate.css';
    .new-container{
        padding: 0 8%;
    }
    .new-header-container{
        padding: 0 8%;
    }
    @media only screen and (max-width: 1100px){
        .new-container{
            padding-left: 10%;
            padding-right: 10%;
        }
        .new-header-container{
            padding-left: 8%;
            padding-right: 8%;
        }
    }   
    @media only screen and (max-width: 500px){
        .new-container{
            padding-left: 5%;
            padding-right: 5%;
        }
    }     
</style>
